import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { PROFILE } from '../routes/paths';
import { getAuthToken } from '../utils/authSession';

function GuestRoute({ children, allowIncompleteAccount = false }) {
  // Check on entry so successful OTP verification can finish its own redirect.
  const [alreadyLoggedIn] = useState(() => Boolean(getAuthToken()) && !(allowIncompleteAccount && localStorage.getItem('isCompleteAccount') !== 'true'));
  return alreadyLoggedIn ? <Navigate to={PROFILE} replace /> : children;
}

export default GuestRoute;
